module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ka":{"cases":"ჩანაწერები","nocases":"თქვენ არ გაქვთ არც ერთი კონსულტაცია","youcancontactdoctor":"შეგიძლიათ ჩაეწეროთ ონლაინ კონსულტაციაზე, მიხვიდეთ კლინიკაში ან გამოიძახოთ ექიმი სასურველ მისამართზე","gotodoctorspage":"სერვისის მისაღებად შეარჩიეთ","doctors":"ექიმი"}}')
  delete Component.options._Ctor
}
